// src/views/pages/Unauthorized.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import DashboardIcon from '@mui/icons-material/Dashboard';

const Unauthorized = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
      }}
    >
      <LockIcon
        sx={{
          fontSize: 80,
          color: 'error.main',
          mb: 2,
          opacity: 0.8,
        }}
      />
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        Access Denied
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        You don't have permission to access this page.
      </Typography>
      <Button
        variant="contained"
        color="info"
        startIcon={<DashboardIcon />}
        onClick={() => navigate('/dashboard')}
        sx={{ borderRadius: 2, textTransform: 'none', px: 4, py: 1.2 }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default Unauthorized;
